import React, { forwardRef } from 'react';
const FormControlErrorText = (StyledFormControlErrorText) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledFormControlErrorText ref={ref} {...props}>
        {children}
      </StyledFormControlErrorText>);
});
export default FormControlErrorText;
